import React, { Fragment } from "react";
import { Route, Redirect } from "react-router-dom";
import Admin from "layouts/AdminLayout";

import Star from "@material-ui/icons/Star";
import Report from "@material-ui/icons/Report";
import Dns from "@material-ui/icons/Dns";

import Picks from "views/Picks/Picks.jsx";
import Reports from "views/Reports/Reports.jsx";
import Wheels from "views/Wheels/Wheels.jsx";
import Addressables from "views/Addressables/Addressables.jsx";
import PrivateRoute from "./PrivateRoute";

export const adminRoutesMap = [
  {
    path: "/picks",
    name: "Krikey Picks",
    icon: Star,
    component: Picks,
    layout: "/admin",
    roles: ['admin', 'content-admin']
  },
  {
    path: "/reported",
    name: "Reported Items",
    icon: Report,
    component: Reports,
    layout: "/admin",
    roles: ['admin', 'content-admin']
  },
  {
    path: "/wheel",
    name: "Camera Wheel",
    icon: "content_paste",
    component: Wheels,
    layout: "/admin",
    roles: ['admin', 'developer-admin']
  },
  {
    path: "/addressables",
    name: "Addressables",
    icon: Dns,
    component: Addressables,
    layout: "/admin",
    roles: ['admin', 'developer-admin']
  }
];

const AdminRoutes = ({ match: { url }, ...rest }) => {
  const userRole = localStorage.getItem('role')
  const authorizedRoutes = adminRoutesMap.filter(route => route.roles.includes(userRole))

  if (adminRoutesMap.map(({ path }) => `/admin${path}`).includes(window.location.pathname)) {
    return adminRoutesMap.map(({ layout, path, component: Component, roles, redirectPath }) => {
      const View = () => {
        return (
          <Admin routes={authorizedRoutes} {...rest}>
            <Component routes={authorizedRoutes}  {...rest} />
          </Admin>
        )
      }

      return (
        <PrivateRoute
          key={`${layout}${path}`}
          path={`${layout}${path}`}
          component={View}
          {...{ roles, redirectPath }}
        />
      )

    })
  } else {
    return (<Redirect to={`/admin${authorizedRoutes[0].path}`} />)
  }
}

export default AdminRoutes;